"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributesByFilterOptions = void 0;
const table_columns_1 = require("../../../../../../common/table-columns");
const product_table_dynamic_columns_1 = require("../../../../../../hooks/product-table-dynamic-columns");
const getAttributesByFilterOptions = (attributes, filterOptions = []) => {
    if (!filterOptions.length || filterOptions.length === Object.values(product_table_dynamic_columns_1.DynamicColumnsFilterOption).length) {
        return attributes;
    }
    const newAttributes = attributes.filter(({ id }) => {
        var _a;
        const { isAIEnriched, isMeasure } = (_a = (0, table_columns_1.parseColumnId)(id).dataMeta) !== null && _a !== void 0 ? _a : {};
        if (filterOptions.includes(product_table_dynamic_columns_1.DynamicColumnsFilterOption.Enriched) && isAIEnriched) {
            return true;
        }
        if (filterOptions.includes(product_table_dynamic_columns_1.DynamicColumnsFilterOption.Measures) && isMeasure) {
            return true;
        }
        if (filterOptions.includes(product_table_dynamic_columns_1.DynamicColumnsFilterOption.Original) && (!isMeasure && !isAIEnriched)) {
            return true;
        }
        return false;
    });
    return newAttributes;
};
exports.getAttributesByFilterOptions = getAttributesByFilterOptions;
